import React from 'react';

import { useTranslation } from "react-i18next";

import logo from '../img/logo.png'
import iberdrola from '../img/iberdrola.svg'

const { hostname } = document.location;

function Footer() {

  const { t } = useTranslation();

  return (
    <div className='bg-[#EFEFEF] z-10 relative'>
      <div className='flex flex-col xl:flex-row max-w-[1220px] mx-[20px] xl:mx-auto pt-[160px] gap-[20px] xl:gap-[45px] items-start justify-between'>
        <img src={logo} alt="" className='w-[96.875px] xl:h-[75px]' />
        <div className='flex flex-col gap-[15px]'>
          <p className='font-[300] text-[14px] text-[#0C2780] open-sans'>{t('footer.1')}</p>
          <p className='font-[300] text-[14px] text-[#0C2780] open-sans'>{t('footer.2')} {t('footer.9')}<br />{t('footer.10')}</p>
          <p className='text-[#0C2780] open-sans text-[14px] font-[300]'>
            <b className='font-[600]'>LEI:</b> <a href="https://search.gleif.org/#/record/506700YEL719Z2T05K30" className='hover:font-[600] transition-all'>506700YEL719Z2T05K30</a>
          </p>
          <a href={`mailto:support@${hostname}`} className='font-[300] text-[14px] text-[#0C2780] open-sans'>
            {t('footer.3')} support@{hostname}
          </a>
          <a href={`tel:+441235643235`} className='font-[300] text-[14px] text-[#0C2780] open-sans'>
            {t('footer.333')} +441235643235
          </a>
        </div>
        <div className='flex flex-col gap-[15px]'>
          <a href="/docs/Client_agreement.pdf" target="_blank"><p className='font-[300] text-[14px] text-[#0C2780] open-sans hover:font-[400] transition-all'>{t('footer.4')}</p></a>
          <a href="/docs/PRIVACY_POLICY.pdf" target="_blank"><p className='font-[300] text-[14px] text-[#0C2780] open-sans hover:font-[400] transition-all'>{t('footer.5')}</p></a>
        </div>
        <img src={iberdrola} alt="" className='w-[150px] xl:w-[200px]'/>
      </div>
      <div className='flex flex-col max-w-[1220px] mx-[20px] xl:mx-auto pt-[20px] xl:pt-[40px] pb-[20px]'>
        <p className='text-[#0C2780] open-sans text-[14px] font-[600]'>{t('footer.7')}</p>
        <p className='text-[#0C2780] open-sans text-[14px] font-[300] mt-[10px]'>{t('footer.8')}</p>
        <p className='text-[#0C2780] open-sans text-[14px] mt-[10px] font-[600] xl:ml-auto'>{t('footer.11')}</p>
      </div>
    </div>
  );
}

export default Footer;